import { useContext } from "react";
import { GlobalContext } from "@/context/GlobalContext";

function useLocationDrawer() {
	const { locationSelectorOpen, setLocationSelectorOpen } =
		useContext(GlobalContext);

	function toggleLocationDrawer() {
		setLocationSelectorOpen(!locationSelectorOpen);
	}

	return toggleLocationDrawer;
}
export default useLocationDrawer;
